/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Api key update request
 */
export interface LakeApiKeyUpdateRequest {
  id: number;
  name?: string;
  /**
   * Optional CIDR block to restrict keys to. E.g. a.b.c.0/24. Blank - allow all IPs. Separator - \'|\'
   */
  cidr?: string;
}
